export default __webpack_public_path__ + "media/src/features/footer/assets/google_play-1f2d0e2396115a9e956ed90baa3ef7ec.svg";